import React, { useEffect, useMemo, useState } from 'react';
import Slider from 'react-slick';

import { CustomNextArrow, CustomPrevArrow } from './CustomSliderArrows';

import carouselFirstSlide from '../../../main/assets/images/auvsi/simulator-slide-one.webp';
import carouselSecondSlide from '../../../main/assets/images/auvsi/simulator-slide-two.webp';
import carouselThirdSlide from '../../../main/assets/images/auvsi/simulator-slide-three.webp';
import carouselFirstSlideTablet from '../../../main/assets/images/auvsi/simulator-slide-one-tablet.webp';
import carouselSecondSlideTablet from '../../../main/assets/images/auvsi/simulator-slide-two-tablet.webp';
import carouselThirdSlideTablet from '../../../main/assets/images/auvsi/simulator-slide-three-tablet.webp';
import carouselFirstSlideMobile from '../../../main/assets/images/auvsi/simulator-slide-one-mobile.webp';
import carouselSecondSlideMobile from '../../../main/assets/images/auvsi/simulator-slide-two-mobile.webp';
import carouselThirdSlideMobile from '../../../main/assets/images/auvsi/simulator-slide-three-mobile.webp';

export const Simulator = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const SimulatorSliderSettings = useMemo(() => {
    let showArrows = true;
    let centerMode = true;
    let centerPadding = '10%';
    let className = 'center';

    if (windowWidth <= 1900 && windowWidth > 1200) {
      showArrows = false;
    } else if (windowWidth <= 1200) {
      centerMode = false;
      centerPadding = '0';
      className = '';
    }

    return {
      arrows: showArrows,
      prevArrow: showArrows ? <CustomPrevArrow /> : undefined,
      nextArrow: showArrows ? <CustomNextArrow /> : undefined,
      className,
      centerMode,
      infinite: true,
      dots: true,
      speed: 200,
      slidesToShow: 1,
      centerPadding,
      slidesToScroll: 1,
      focusOnSelect: true,
    };
  }, [windowWidth]);

  const slides = useMemo(() => {
    const slidesData = [
      {
        desktopImage: carouselSecondSlide,
        tabletImage: carouselSecondSlideTablet,
        mobileImage: carouselSecondSlideMobile,
        title: 'Built for real ops',
        tags: ['FPV', 'Tactics', 'Training', 'Combat'],
        description:
          'Mission execution is just the beginning. The simulator sharpens decision-making, reinforces protocols, and prepares you for real-world operations.',
      },
      {
        desktopImage: carouselThirdSlide,
        tabletImage: carouselThirdSlideTablet,
        mobileImage: carouselThirdSlideMobile,
        title: 'Tactical focus',
        tags: ['FPV', 'Tactics', 'Training', 'Combat'],
        description:
          'Tactical flight training under combat conditions, maintaining target focus and executing with precision under pressure.',
      },
      {
        desktopImage: carouselFirstSlide,
        tabletImage: carouselFirstSlideTablet,
        mobileImage: carouselFirstSlideMobile,
        title: 'Mission Readiness',
        tags: ['FPV', 'Tactics', 'Training', 'Combat'],
        description:
          'Every mission begins with control. From takeoff to formation discipline, the simulator builds the foundation for operational readiness.',
      },
    ];

    return slidesData.map(slide => ({
      ...slide,
      image:
        windowWidth <= 834
          ? slide.mobileImage
          : windowWidth <= 1900
          ? slide.tabletImage
          : slide.desktopImage,
    }));
  }, [windowWidth]);

  return (
    <div className="auvsi-simulator-section">
      <div className="auvsi-simulator-section-text">
        <h2 className="auvsi-simulator-title">Simulator</h2>
        <p className="auvsi-simulator-description">
          ORQA Defense Sim - the ultimate tactical FPV simulator - is designed
          for both pilots and tactical operators. It challenges your ability to
          maneuver FPV systems in dynamic environments, plan missions, and
          execute them using digital-twin equipment setups.
        </p>
      </div>
      <div className="auvsi-simulator-carousel" style={{ width: '100%' }}>
        <Slider {...SimulatorSliderSettings}>
          {slides.map((slide, index) => (
            <div
              key={index}
              style={{
                padding: windowWidth > 1200 ? '10px' : '0',
              }}
            >
              <div
                className="auvsi-simulator-slide"
                style={{
                  background: `url(${slide.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  width: '100%',
                  overflow: 'hidden',
                }}
              >
                <h2 className="auvsi-simulator-slide-title">{slide.title}</h2>
                <div className="auvsi-simulator-container-tags">
                  {slide.tags.map((tag, i) => (
                    <div key={i} className="auvsi-simulator-container-tag">
                      <p className="auvsi-simulator-tag-text">{tag}</p>
                    </div>
                  ))}
                </div>
                <p className="auvsi-simulator-slide-description">
                  {slide.description}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
